












































import {
	defineComponent,
	PropType,
	watch,
	nextTick,
	Ref,
	ref,
	onMounted,
} from '@vue/composition-api';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import { Address } from '@front-app/services/SharedModels';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { sleep } from '@front-app/util/async';
import TrAddress from '../TrAddress.vue';
import '@front-app/vendor/add-to-calendar-legacy';

export default defineComponent({
	components: {
		IconButton,
		FontAwesomeIcon,
		TrAddress,
	},
	props: {
		start: {
			type: Date,
			required: true,
		},
		end: {
			type: Date,
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			default: '',
		},
		address: {
			type: Object as PropType<Address>,
			default: () => ({}),
		},
	},
	setup(props) {
		const el: Ref<null | HTMLElement> = ref(null);
		const initCalendar = async () => {
			await nextTick();
			await nextTick();
			await sleep(100);
			await nextTick();
			const atc = window.addtocalendar;
			const existing = el.value?.querySelector('.atcb-list');
			if (atc) {
				if (existing) {
					existing.parentElement?.removeChild(existing);
				}
				atc.load();
			}
		};
		watch(props, initCalendar, { immediate: true });

		onMounted(initCalendar);

		const isOpen = ref(false);
		const toggleDropdown = () => {
			isOpen.value = !isOpen.value;
			const listEl = el.value?.querySelector('.atcb-list');
			if (!listEl) {
				return;
			}

			listEl.classList.toggle('atcb-list__visible', isOpen.value);
		};

		return {
			el,
			toggleDropdown,
		};
	},
});
